import { Select } from 'antd';
import PropTypes from 'prop-types';
import ExcelButton from '../Button/ExcelButton';

const SelectTamanoPagina = ({
  onChange,
  onClick,
  value,
  disableBottomExcel,
  showExcelButton,
  labelExcelButton
}) => {
  return (
    <div className="col-header-table-col1">
      <span style={{ marginRight: '0.5em' }}>Mostrar </span>
      <Select
        placeholder="10"
        value={value}
        onChange={onChange}
        options={[
          {
            value: 10,
            label: '10'
          },
          {
            value: 20,
            label: '20'
          },
          {
            value: 50,
            label: '50'
          }
        ]}
      />
      <span style={{ margin: '0 0.5em' }}>registros</span>
      {showExcelButton && (
        <>
          <ExcelButton
            type="text"
            style={{ marginTop: -10 }}
            onClick={onClick}
            disabled={disableBottomExcel}
          />
          {labelExcelButton && (
            <span style={{ margin: '0 0.5em', fontWeight: '500', color: '#c12b7d' }}>
              {labelExcelButton}
            </span>
          )}
        </>
      )}
    </div>
  );
};

SelectTamanoPagina.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  disableBottomExcel: PropTypes.bool.isRequired,
  showExcelButton: PropTypes.bool,
  labelExcelButton: PropTypes.string
};

SelectTamanoPagina.defaultProps = {
  showExcelButton: true,
  labelExcelButton: null
};

export default SelectTamanoPagina;
